<template>
    <div id="project-stats-dashboard-page">
        <div class="container-fluid">
            <div class="vx-row mb-4">
                <!-- FILTROS -->
                <div class="vx-col sm:w-full md:w-2/3 lg:w-2/3 mb-4">
                    <vx-card title="Filtros.">
                        <div class="vx-row">
                            <div class="vx-col sm:w-full md:w-1/4 lg:w-1/4 mb-1">
                                <label for="">Mes:</label>
                                <vs-select
                                    v-model.number="month"
                                    class="w-full select-large"
                                    v-validate="'required'"
                                    name="sourceType"
                                    placeholder="Seleccione una opción" >
                                <vs-select-item
                                    :key="index"
                                    :value="item.value"
                                    :text="item.text"
                                    v-for="(item,index) in months"
                                    class=""/>
                                </vs-select>
                            </div>
                            <div class="vx-col sm:w-full md:w-1/4 lg:w-1/4 mb-1">
                                <label for="">Año:</label>
                                <vs-select
                                v-model.number="year"
                                class="w-full select-large"
                                v-validate="'required'"
                                name="sourceType"
                                placeholder="Seleccione una opción"
                            >
                                <vs-select-item
                                :key="index"
                                :value="item"
                                :text="item"
                                v-for="(item,index) in years"
                                class=""
                                />
                            </vs-select>
                            </div>
                            <div class="vx-col sm:w-full md:w-1/4 lg:w-1/4 mt-4">
                                <vs-button @click.stop="getStatsData()" style="font-size: 1rem; margin-top: 1rem;" size="small" type="filled" color="success">Filtrar</vs-button>
                            </div>
                        </div>        
                    </vx-card>
                </div>
                <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3 mb-4">
                    <vx-card>
                        <p><strong>Instaladores registrados.</strong></p>
                        <vue-apex-charts v-if="isMounted" type="pie" height="100" :options="chartOptions" :series="chartSeries"></vue-apex-charts>      
                    </vx-card>
                </div>
            </div>

            <div class="vx-row mb-4">
                <!-- ORIGINACIÓN -->
                <div class="vx-col w-full mb-4">
                    <vx-card title="Originación">
                        <vs-table v-if="isMounted" :data="newOrigination" stripe noDataText="No hay datos disponibles">
                            <template slot="thead">
                                <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td class="left">
                                        <strong>
                                            {{ tr.name }}
                                        </strong>
                                    </vs-td>
                                    <vs-td>
                                        <strong>
                                            {{ moneyFormatNoCents(tr.annual_goal) }}
                                        </strong>
                                    </vs-td>
                                    <vs-td>
                                        <strong>
                                            {{ moneyFormatNoCents(tr.monthly_average) }}
                                        </strong>
                                    </vs-td>
                                    <!-- <vs-td>
                                        {{ tr.percentage.toFixed(0) }}
                                    </vs-td> -->
                                    <vs-td v-for="(month, mIndex) in months">
                                        {{ moneyFormatNoCents(tr[`month_${mIndex}`]) }} 
                                    </vs-td>
                                    <vs-td>
                                        {{ moneyFormatNoCents(tr.current) }}
                                    </vs-td>
                                    <vs-td>
                                        {{ moneyFormatNoCents(tr.missing) }}
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vx-card>
                </div>
                <!-- OPS -->
                <div class="vx-col w-full mb-4">
                    <vx-card title="Servicios operativos">
                        <vs-table v-if="isMounted" :data="newOps" stripe noDataText="No hay datos disponibles">
                            <template slot="thead">
                                <vs-th class="bold" v-for="(col, idx) in opsColumns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td class="left">
                                        <strong>
                                            {{ tr.type == 'originacion_special' ? "Originación" : tr.type}}
                                        </strong>
                                    </vs-td>
                                    <vs-td class="left">
                                        <strong>
                                            {{ tr.name }}
                                        </strong>
                                    </vs-td>
                                    <vs-td v-for="(month, mIndex) in months">
                                        <div :class=" tr[`need_tooltip${mIndex}`] ? 'clickable-img primary' : ''" @click="handleSupplierList( tr[`project_list_${mIndex}`], tr[`need_tooltip${mIndex}`], true)">
                                            {{ tr[`month_${mIndex}`] }} 
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <strong>
                                            {{ (tr.name == "Monto aprobado" || tr.name == "Monto solicitudes completas") ? moneyFormatNoCents(tr.total) : tr.total }} 
                                        </strong>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vx-card>
                </div>
                <!-- INSTALADORES -->
                <div class="vx-col w-full mb-4">
                    <vx-card title="Instaladores">
                        
                        <vs-table v-if="isMounted" :data="newSupplierStats" stripe noDataText="No hay datos disponibles">
                            <template slot="thead">
                                <vs-th class="bold" v-for="(col, idx) in opsColumns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td class="left">
                                        <strong>
                                            {{ tr.type }}
                                        </strong>
                                    </vs-td>
                                    <vs-td class="left">
                                        <strong>
                                            {{ tr.name }}
                                        </strong>
                                    </vs-td>
                                    <vs-td v-for="(month, mIndex) in months">
                                        <div class="clickable-img primary" @click="handleSupplierList(tr[`project_list_${mIndex}`], true, false)">
                                            {{ tr[`month_${mIndex}`] }} 
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <strong>
                                            {{ tr.total }} 
                                        </strong>
                                    </vs-td>                                    
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vx-card>
                </div>
            </div>
        </div>


        <vs-popup id="project-list-dash" title="Detalle" :active.sync="showSupplierListPrompt">
            <vx-card class="mb-4">
                <h1 class="bold big-title m-0">Lista de <span>{{ isProjects ? "proyectos" : "instaladores" }}</span>.</h1>
            </vx-card>
            <vx-card class="mb-4">
                <ul class="grid-list">
                    <li v-for="(tr, index) in currentSupplierList" >
                        <div v-if="isProjects">
                            <router-link :to="`/project/${tr.pid}`" target="_blank">
                                {{ tr.id_alias }} <br>
                            </router-link>
                        </div>
                        <div v-else>
                            <router-link :to="`/suppliers/${tr.sid}`" target="_blank">
                                {{ tr.supplier }} <br>
                            </router-link>
                        </div>
                    </li>
                </ul>
            </vx-card>
        </vs-popup>
    </div>
</template>
  
<script>
import formatHelper from '@mixins/formatHelper';
import VueApexCharts from 'vue-apexcharts';
const months = [
	{ value: 1, text: "Enero" }
	,{ value: 2, text: "Febrero" }
	,{ value: 3, text: "Marzo" }
	,{ value: 4, text: "Abril" }
	,{ value: 5, text: "Mayo" }
	,{ value: 6, text: "Junio" }
	,{ value: 7, text: "Julio" }
	,{ value: 8, text: "Agosto" }
	,{ value: 9, text: "Septiembre" }
	,{ value: 10, text: "Octubre" }
	,{ value: 11, text: "Noviembre" }
	,{ value: 12, text: "Diciembre" }
];

export default {
    name: 'project-stats-dashboard',
    props: [],
    mixins: [formatHelper],
    components: { VueApexCharts },
    mounted() {
        this.initDates();
        this.getStatsData();
    },
    data() {
        return {
            month: 0
            , months: months
            , year: 0
            , years: []
            , data: []
            , columns: [
                { title: "Meta", key: "goal", sortable: false },
                { title: "Anual", key: "annual", sortable: false },
                { title: "Prom. Mensual", key: "average", sortable: false },
                // { title: "M", key: "m", sortable: false },
                // { title: "%", key: "percentage", sortable: false },
            ]
            , opsColumns: [
                { title: "Tipo", key: "type", sortable: false },
                { title: "Servicio", key: "service", sortable: false },
            ]
            , supplierColumns: [
                { title: "Tipo", key: "type", sortable: false },
                { title: "Servicio", key: "service", sortable: false },
            ],
            isMounted: false,
            newOrigination: [],
            newOps: [],
            newSupplierStats: [],
            chartSeries: [0,0,0],
            chartOptions: {
                colors: ['#28DE18', '#3B3A3E', '#CBFF00'],
                dataLabels: { enabled: true },
                donut: { labels: { show: true} },
                legend: { show: true},
                tooltip: { y: { formatter: (value) =>{return value} } },
                labels: ["Verificados", "Rechazados", "No verificados"],
            },
            showSupplierListPrompt: false
            , currentSupplierList: []
            , isProjects: false
        }
    },
    methods: {
        initDates() {
            let date = new Date();
            this.year = date.getFullYear();
            this.month = date.getMonth()+1;
            let i = date.getFullYear();
            for(i; i>=2016; i--) {
                this.years.push(i);
            }
        },
        async getStatsData() {
            this.showLoading(true);
            try {
                const res = await axios.get(`/api/get/supplier/annual-project-stats?year=${this.year}&month=${this.month}`);
                this.data = res.data;
                await this.setHeaders();
                await this.initDonutChart();
                this.manageOrigination();
                this.manageOPS();
                this.manageSupplierStats();
                this.isMounted = true;
                this.showLoading(false);
            } catch (error) {
                console.error(error);
                this.showLoading(false);
                this.failedOperationNotif("Error");
            }

        },
        setHeaders() {
            this.columns = [
                { title: "Meta", key: "goal", sortable: false },
                { title: "Anual", key: "annual", sortable: false },
                { title: "Prom. Mensual", key: "average", sortable: false },
                // { title: "M", key: "", sortable: false },
                // { title: "%", key: "percentage", sortable: false },
            ];

            this.opsColumns = [
                { title: "Tipo", key: "type", sortable: false },
                { title: "Servicio", key: "service", sortable: false },
            ];
            
            this.supplierColumns = [
                { title: "Tipo", key: "type", sortable: false },
                { title: "Servicio", key: "service", sortable: false },
            ];

            let totalColumn = { title: "Total", key: "total", sortable: false };
        

            let count = 0;
            this.data.forEach(column => {
                let obj = {
                    title: `${this.setMonthShortName(column.month)} ${column.year}`
                    , key: `${column.month}_${count}`
                    , sortable: false
                };
                this.columns.push(obj);
                this.opsColumns.push(obj);
                this.supplierColumns.push(obj);
                count++;
            });

            this.opsColumns.push(totalColumn);
            this.supplierColumns.push(totalColumn);

            this.columns.push(
                { title: "ACUMULADO", key: "sum", sortable: false },
                { title: "FALTANTE", key: "sum", sortable: false }
            )
        },
        manageOrigination() {
            const origination = this.data[0].origination;

            this.newOrigination = [];

            // Este ciclo recorre las categorías  del reporte
            for (let i = 0; i < origination.length; i++) {
                // Este ciclo debe correr los meses
                let element = origination[i];
                let current = 0;
                for (let j = 0; j < this.data.length; j++) {
                    let currentData = this.data[j].origination[i];
                    // Crea el valor para el mes j
                    element[`month_${j}`] = currentData.monthly_financed_amount;
                    // Acumulado
                    current += currentData.monthly_financed_amount;
                }
                element['current'] = current;
                // Faltante
                element['missing'] = element.annual_goal - current;
                // Y se agrega al nuevo arreglo que se va a mostrar en tabla
                this.newOrigination.push(element);
            }
        },
        manageOPS(){
            const ops = this.data[0].ops;
            this.newOps = [];
            let total = 0;

            // Recorre los ops calculados
            for (let index = 0; index < ops.length; index++) {
                let element = ops[index];
                total = 0;
                // Recorre los meses
                for (let j = 0; j < this.data.length; j++) {
                    let currentData = this.data[j].ops[index];

                    // Sí es un valor en dinero, lo formatea, si no, lo pasa natural
                    element[`month_${j}`] =  currentData.total_amount != null && currentData.data_type == "money" ? this.moneyFormatNoCents(parseInt(currentData.total_amount.toFixed(0))) : currentData.total;
                    element[`project_list_${j}`] = currentData.project_lists;
                    element[`need_tooltip${j}`] = currentData.need_tooltip;

                    // Validaciones especiales
                    if (currentData.name == "Conversión Solicitud Completa a Publicado") {
                        element[`month_${j}`] = element[`month_${j}`].toFixed(0) + "%";
                        total = "N/A";
                    } else if (currentData.name == "Monto aprobado" || currentData.name == "Monto solicitudes completas") {
                        total += parseInt(currentData.total_amount.toFixed(0));
                    } else {
                        total += element[`month_${j}`];
                    }
                }
                element["total"] = total;
                this.newOps.push(element);
            }
        },
        manageSupplierStats(){
            this.newSupplierStats = [];
            // let logs = { name: "Tráfico de instaladores", type: "Actividad de instaladores", total: 0};
            let simulations = { name: "Instaladores con simulación", type: "Actividad de instaladores", total: 0};
            let withLoanRequest = { name: "Instaladores con solicitud", type: "Actividad de instaladores", total: 0};
            let registered = { name: "Registro instaladores", type: "Onboarding Instaladores", total: 0};
            let completed = { name: "Instaladores con perfil completo", type: "Onboarding Instaladores", total: 0};
            let verified = { name: "Instaladores Verificados", type: "Onboarding Instaladores", total: 0};
            let suppliers_percentage = { name: "Conversión de instaladores registrados a verificados", type: "Onboarding Instaladores", total: 0};
            // Recorre los meses
            for (let j = 0; j < this.data.length; j++) {
                // Objeto con arreglos
                let currentData = this.data[j].stats; 
                // Armamos un objeto nuevo
                let percentage = (currentData.suppliers_pre_selected.length * 100) / (currentData.suppliers_in_verification.length <= 0 ? 1 : currentData.suppliers_in_verification.length);
                // Para cada objeto, se guarda su valor por mes 
                // logs[`month_${j}`] = currentData.logs.length;
                simulations[`month_${j}`] = currentData.simulation_data.length;
                withLoanRequest[`month_${j}`] = currentData.suppliers_with_request.length;
                registered[`month_${j}`] = currentData.suppliers_registered.length;
                completed[`month_${j}`] = currentData.suppliers_in_verification.length;
                verified[`month_${j}`] = currentData.suppliers_verified.length;
                suppliers_percentage[`month_${j}`] = `${percentage.toFixed(0)}%`;

                // logs[`project_list_${j}`] = currentData.supplier_logins;
                simulations[`project_list_${j}`] = currentData.simulation_data;
                withLoanRequest[`project_list_${j}`] = currentData.suppliers_with_request;
                registered[`project_list_${j}`] = currentData.suppliers_registered;
                completed[`project_list_${j}`] = currentData.suppliers_in_verification;
                verified[`project_list_${j}`] = currentData.suppliers_verified;
                suppliers_percentage[`project_list_${j}`] = currentData.suppliers_pre_selected;

                // Calcular totales
                // logs["total"] += currentData.logs.length;
                simulations["total"] += currentData.simulation_data.length;
                withLoanRequest["total"] += currentData.suppliers_with_request.length;
                registered["total"] += currentData.suppliers_registered.length;
                completed["total"] += currentData.suppliers_in_verification.length;
                verified["total"] += currentData.suppliers_verified.length;
                suppliers_percentage["total"] = "N/A";
            }
            this.newSupplierStats = [
                // logs
                simulations
                , withLoanRequest
                , registered
                , completed
                , verified
                , suppliers_percentage
            ];

        },
        initDonutChart()
        {
            const chartData = this.data[0].supplier_status;
            this.chartSeries = [];
            this.chartSeries.push(chartData.verified);
            this.chartSeries.push(chartData.rejected);
            this.chartSeries.push(chartData.notVerified);
        },
        handleSupplierList(data, needTooltip, isProjects = false){
            if(needTooltip && data.length > 0){
                this.currentSupplierList = data;
                this.showSupplierListPrompt = true;
                this.isProjects = isProjects;
            } else {
                this.missingFieldsNotif("Sin información", "No hay lista de proveedores por mostrar.");
            }
        },
        setMonthShortName(month){
            switch(month){
                case "January":
                    return "ENE";
                case "February":
                    return "FEB";
                case "March":
                    return "MAR";
                case "April":
                    return "ABR";
                case "May":
                    return "MAY";
                case "June":
                    return "JUN";
                case "July":
                    return "JUL";
                case "August":
                    return "AGO";
                case "September":
                    return "SEPT";
                case "October":
                    return "OCT";
                case "November":
                    return "NOV";
                case "December":
                    return "DIC";
            }
        },
    }
}
</script>
  
<style>

#project-stats-dashboard-page table {
    font-size: .8rem !important;
}

#project-stats-dashboard-page .vs-con-table td   {
    padding: 2px 8px !important;
    text-align: center;
}

.left {
    text-align: left !important;
}

.vs-popup--header{
    background-color: #28de18 !important;
}

.vs-popup--title h3 {
    color: white !important;
}

.grid-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

#project-list-dash .vs-popup {
    width: 60% !important;
}

</style>
  